export default __webpack_public_path__ + "static/media/duplicate.671e25b1.svg";